// What each login is, in one place.
//
// The server is what actually enforces any of this (middleware/auth.js and the
// per-route guards); these helpers only decide what is worth putting on screen,
// so nobody is offered a button that would come back refused.

// The two order-desk logins: the counter and the floor. Both open the order
// list, read an order, and move its status along — and nothing else.
export const MANAGER_ROLES = ['STORE_MANAGER', 'WORKSHOP_MANAGER'];

export const isManager = (role) => MANAGER_ROLES.includes(role);

/**
 * The logins the server holds to an account group's switches — workers,
 * supervisors, and the two manager desks (middleware/auth.js). Their menu is
 * decided by Portal Access rather than by their role, so they are also the
 * ones that have to ask the server what they may open.
 */
export const hasPortalGroup = (role) => role === 'WORKER' || isManager(role);

export const ROLE_LABEL = {
  ADMIN: 'Admin',
  SUPERVISOR: 'Supervisor',
  STAFF: 'Staff',
  STORE_MANAGER: 'Store Manager',
  WORKSHOP_MANAGER: 'Workshop Manager',
  VIEWER: 'Viewer',
  WORKER: 'Worker',
};

/** Where this login lands when it signs in, or clicks the logo. */
export const homeFor = (role) => {
  if (role === 'WORKER') return '/portal';
  if (isManager(role)) return '/invoices';
  return '/dashboard';
};

/**
 * The paths a manager login may open with no Portal Access switch behind them.
 * An area guarded by a `need` is decided by that switch instead, so a manager
 * given Workers reaches it without having to be listed here.
 */
const MANAGER_PATHS = [
  /^\/invoices\/?$/,
  /^\/invoices\/\d+\/?$/, // one order, read-only
  /^\/change-password\/?$/,
];

export const managerMayOpen = (pathname) => MANAGER_PATHS.some((p) => p.test(pathname));
